export const CERTIFICATE_TYPE_ORDER = ["COC", "EN_10204_2_2", "EN_10204_3_1"];

export const normalizeCertificateTypes = (values, legacyType = "NONE") => {
  const source = Array.isArray(values) && values.length ? values : legacyType && legacyType !== "NONE" ? [legacyType] : [];
  const selected = new Set(source.filter(type => CERTIFICATE_TYPE_ORDER.includes(type)));
  return CERTIFICATE_TYPE_ORDER.filter(type => selected.has(type));
};

export const certificateTypesFrom = (...sources) => {
  for (const source of sources.filter(Boolean)) {
    if (Array.isArray(source.certificateTypes)) return normalizeCertificateTypes(source.certificateTypes);
    if (Array.isArray(source.certificate_types)) return normalizeCertificateTypes(source.certificate_types);
  }
  for (const source of sources.filter(Boolean)) {
    const lines = source.certificateLines || source.certificate_lines;
    if (Array.isArray(lines) && lines.length) return normalizeCertificateTypes(lines.map(line => line.certificate_type || line.type));
  }
  const legacy = sources.find(source => source?.certificateType || source?.certificate_type);
  return normalizeCertificateTypes([], legacy?.certificateType || legacy?.certificate_type || "NONE");
};

export const certificateEntriesFrom = (...sources) => {
  for (const source of sources.filter(Boolean)) {
    const lines = source.certificateLines || source.certificate_lines;
    if (Array.isArray(lines) && lines.length) return lines.map(line => ({
      type: line.certificate_type || line.type,
      label: line.certificate_label || line.label,
      price: line.certificate_price_ex_vat ?? line.price ?? line.unit_price ?? 0,
      currency: line.currency || source.currency,
    })).filter(line => CERTIFICATE_TYPE_ORDER.includes(line.type));
  }
  const types = certificateTypesFrom(...sources);
  if (types.length !== 1) return [];
  const source = sources.find(Boolean) || {};
  return [{
    type: types[0],
    label: source.certificateLabel || source.certificate_label,
    price: source.certificatePriceExVat ?? source.certificate_price_ex_vat ?? 0,
    currency: source.currency,
  }];
};